import {
	createContext,
	type Dispatch,
	type ReactNode,
	type SetStateAction,
	useContext,
	useState,
} from 'react'

export type PactDeclaredUnit =
	| 'liter'
	| 'kilogram'
	| 'cubic meter'
	| 'kilowatt hour'
	| 'megajoule'
	| 'ton kilometer'
	| 'square meter'
	| 'piece'
	| 'hour'
	| 'megabit second'

export const PACT_UNIT_LABEL: Partial<Record<PactDeclaredUnit, string>> = {
	liter: 'l',
	kilogram: 'kg',
	'cubic meter': 'm³',
	'kilowatt hour': 'kWh',
	megajoule: 'MJ',
	'ton kilometer': 't·km',
	'square meter': 'm²',
	piece: 'piece',
	hour: 'h',
	'megabit second': 'Mbit·s',
}

const DeclaredUnitContext = createContext<PactDeclaredUnit | undefined>(
	undefined
)
const SetDeclaredUnitContext = createContext<
	Dispatch<SetStateAction<PactDeclaredUnit | undefined>>
>(() => undefined)

interface DeclaredUnitProviderProps {
	children: ReactNode
}

export const DeclaredUnitProvider = ({
	children,
}: DeclaredUnitProviderProps) => {
	const [declaredUnit, setDeclaredUnit] = useState<
		PactDeclaredUnit | undefined
	>(undefined)

	return (
		<SetDeclaredUnitContext.Provider value={setDeclaredUnit}>
			<DeclaredUnitContext.Provider value={declaredUnit}>
				{children}
			</DeclaredUnitContext.Provider>
		</SetDeclaredUnitContext.Provider>
	)
}

export const useDeclaredUnit = (): PactDeclaredUnit | undefined =>
	useContext(DeclaredUnitContext)

export const useSetDeclaredUnit = (): Dispatch<
	SetStateAction<PactDeclaredUnit | undefined>
> => useContext(SetDeclaredUnitContext)
